import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError, of} from 'rxjs';
import {RateTypes} from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class RateTypesService extends DataService {

  private baseURI = this.apiUri + '/ratetypes/';
  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
  }

  // This Service is to get all HHG Rates by transportation type
  getRateTypesListByBusinessTypeAndTransportationType(transportationType: string): Observable<RateTypes[]> {
    this.setUri(this.baseURI + 'HHG/businesstype/' + transportationType + '/transportationtype');
    return this.get().pipe(catchError(this.handleError));
  }

  getRateTypesListByBusinessType(businessType: string): Observable<RateTypes[]> {
    this.setUri(this.baseURI + businessType.toUpperCase() + '/businesstype/orderbyratetypeid');
    return this.get().pipe(catchError(this.handleError));
  }

}
